module.exports = __webpack_public_path__ + "public/img/ico-listitem-more.1322352f.svg";